<!-- 首页// 碳排放/标煤  -->
<template>
  <div class="box">
    <Title :text="home.CarbonEmission.Title[0]" :engText="home.CarbonEmission.Title[1]"></Title>
    <div class="content">
		<div class="content-title">
		  <div class="a">
		    [
		    <div :class="`${active === 1 ? 'active' : ''}`" @click="fn1(1)">本日</div>
		    <div :class="`${active === 2 ? 'active' : ''}`" @click="fn1(2)">本月</div>
		    <div :class="`${active === 3 ? 'active' : ''}`" @click="fn1(3)">本年</div>
		    ]
		  </div>
		</div>
		<div class="mdbc1">
			<div class="left">
				<div class="echarts-content">
				  <chart-block ref="echart"></chart-block>
				</div>
			</div>
			<div class="right">
				<div class="a">排放量：<span class="white">10000t/9000tce</span></div>
				<div class="b">
					<div class="b1">
						<div class="t">
							<div class="yellow"></div>
							<div>同比</div>
						</div>
						<div class="t">
							<div class="text">35%</div>
							<div class="add"></div>
						</div>
					</div>
					<div class="b2">
						<div class="t">
							<div class="blue"></div>
							<div>环比</div>
						</div>
						<div class="t">
							<div class="text">65%</div>
							<div class="reduce"></div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="mdbc2">
			<div class="left">
				<div class="a">
					<div class="icon1"></div>
					<div class="b1">
						<div >水（t/tce）</div>
						<div class="white">1000/9000</div>
					</div>
					
				</div>
				<div class="a">
					<div class="scale">同比</div>
					<div>
						<span class="white scale">100%</span>
						<span class="add"></span>
					</div>
				</div>
				<div class="a">
					<div class="scale">环比</div>
					<div>
						<span class="white scale">100%</span>
						<span class="reduce"></span>
					</div>
				</div>
			</div>
			<div class="right">
				<div class="b">
					<div class="icon2"></div>
					<div class="b1">
						<div >水（t/tce）</div>
						<div class="white">1000/9000</div>
					</div>
					
				</div>
				<div class="b">
					<div class="scale">同比</div>
					<div>
						<span class="white scale">100%</span>
						<span class="add"></span>
					</div>
				</div>
				<div class="b">
					<div class="scale">环比</div>
					<div>
						<span class="white scale">100%</span>
						<span class="reduce"></span>
					</div>
				</div>
			</div>
		</div>
    </div>
  </div>
</template>

<script>
import Title from '../../components/title/index.vue';
import { mapState,mapActions } from 'pinia' //引入映射函数
import useStore from '@/store/index' //引入store
export default {
  components: {
    Title,
  },
  computed:{
    ...mapState(useStore,['home']) 
  },
  data () {
    return {
      // active 1:日，2:月，3:年
      active:1,
    }
  },
  mounted () {
	  this.$refs.echart.setOption(this.home.CarbonEmission.Option);
  },
  methods: {
    fn1(i){
      this.active = i;
    }
  }
}
</script>

<style scoped>
.box{
   width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.content{
  flex: 1;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
.content-title{
  width: 100%;
  height: 30px;
  display: flex;
  flex-direction: column;
}
.content-title .a{
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
}
.content-title .a > div{
  margin: 0px 10px;
  font-size: 12px;
  cursor: pointer;
}
.active{
  text-shadow: 0px 4px 5px #488dff;
}
.mdbc1{
	width: 100%;
	height: 115px;
	margin: 8px 0px 13px 0px;
	display: flex;
}
.mdbc1 .left{
	width: 117px;
	height: 115px;
	display: flex;
}
.mdbc1 .right{
	flex: 1;
	display: flex;
	flex-direction:column;
	justify-content: space-around;
	
}
.mdbc1 .right .a{
	width: 217px;
	height: 37px;
	background: url('../../assets/img/border1.png') no-repeat;
	background-size: 100% 100%;
	text-align: center;
	line-height: 37px;
}
.mdbc1 .right .b{
	width: 100%;
	display: flex;
	justify-content: space-between;
}
.mdbc1 .right .b1,
.mdbc1 .right .b2{
	width: 102px;
	height: 30px;
	background: url('../../assets/img/border1.2.png') no-repeat;
	background-size: 100% 100%;
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 0px 8px;
	box-sizing: border-box;
}
.mdbc1 .right .b .t{
	display: flex;
	font-size: 12px;
	display: flex;
	justify-content: center;
	align-items: center;
}
.mdbc1 .right  .yellow{
	width: 11px;
	height: 11px;
	background-color: #ffb400;
	margin-right: 5px;
}
.mdbc1 .right  .blue{
	width: 11px;
	height: 11px;
	background-color: #488dff;
	margin-right: 5px;
}
.mdbc2{
	width: 100%;
	height: 85px;
	display: flex;
	justify-content: space-between;
}
.mdbc2 .left,
.mdbc2 .right{
	width: 153px;
	height: 83px;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
}
.mdbc2 .left .a,
.mdbc2 .right .b{
	display: flex;
	justify-content: space-between;
	font-size: 12px;
}
.mdbc2 .left .b1,
.mdbc2 .right .b1{
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	align-items:flex-end;
	
}
.mdbc2 .left .b1 >div:nth-child(2),
.mdbc2 .right .b1 >div:nth-child(2){
	font-size: 14px;
}
.mdbc2 .icon1{
	width: 40px;
	height: 40px;
	background: url('../../assets/img/水滴.png') no-repeat;
	background-size: 100% 100%;
}
.mdbc2 .icon2{
	width: 40px;
	height: 40px;
	background: url('../../assets/img/闪电.png') no-repeat;
	background-size: 100% 100%;
}
.white{
	color: white;
}

</style>